var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hover-fill",
    id: "Sign-In",
    transform: "translate(-934.000000, -739.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M942.678011,756.104139 C942.585097,756.092217 942.492183,756.08022 942.399231,756.068336 C941.969819,756.013382 941.533329,755.990636 941.112017,755.898478 C936.921334,754.982089 934.171069,751.143421 934.633219,746.862587 C934.82181,745.115684 935.504305,743.573419 936.674685,742.271369 C938.208548,740.565 940.143172,739.650466 942.436926,739.519137 C943.943122,739.432846 945.375025,739.716509 946.711629,740.432498 C947.334666,740.766233 947.9001,741.179938 948.426098,741.676756 C947.670028,742.403947 946.923913,743.12164 946.175867,743.841073 C946.142713,743.816965 946.121216,743.80421 946.103088,743.787747 C944.798881,742.604612 943.266381,742.325037 941.604595,742.729621 C939.488873,743.244718 937.940023,745.120982 937.760515,747.298887 C937.618097,749.026829 938.164191,750.503202 939.434525,751.678048 C940.784943,752.926923 942.401842,753.272579 944.167858,752.878138 C945.801712,752.513179 946.905027,751.512202 947.455625,749.921153 C947.505432,749.777107 947.530297,749.624471 947.5728,749.451548 L942.881023,749.451548 L942.881023,746.611397 C942.918113,746.60659 942.942486,746.600686 942.966822,746.600686 C945.496363,746.60008 948.025904,746.600534 950.555445,746.59762 C950.670802,746.597507 950.707892,746.643604 950.719625,746.749765 C950.753952,747.06064 950.795886,747.370645 950.834831,747.681028 L950.834831,748.398682 C950.823098,748.466164 950.803872,748.533342 950.800882,748.60124 C950.772383,749.256522 950.667434,749.89977 950.491862,750.530906 C949.519156,754.028081 946.726692,755.755682 943.898501,756.029013 C943.617752,756.056111 943.336625,756.079198 943.055649,756.104139 L942.678011,756.104139 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGIc);
export default __webpack_public_path__ + "static/media/g-ic.198387043eb0c9abba02403401dd89ed.svg";
export { ForwardRef as ReactComponent };